import { render, staticRenderFns } from "./v-accordion-group.vue?vue&type=template&id=cbe0f720&scoped=true&"
import script from "./v-accordion-group.vue?vue&type=script&lang=js&"
export * from "./v-accordion-group.vue?vue&type=script&lang=js&"
import style0 from "./v-accordion-group.vue?vue&type=style&index=0&id=cbe0f720&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe0f720",
  null
  
)

export default component.exports